<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="bkht_1">
<h1 class="bkht"><a class="page" id="pix"></a>Maria Baldwin’s Worlds</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Weiler0008.vue?d74cc7d0